import { t } from "@lingui/core/macro";
import QRCode from "qrcode";
import { PaymentType } from "./types";

export const getPaymentTypeLabel = (paymentType: PaymentType) => {
  switch (paymentType) {
    case "bank":
      return t`Bancno nakazilo`;
    case "online":
      return t`Spletno placilo`;
    case "paypal":
      return t`PayPal`;
    case "cash":
      return t`Gotovina`;
    case "card":
      return t`Kartica`;
    case "coupon":
      return t`Unovčen darilni bon`;
    case "crypto":
      return t`Kriptovaluta`;
    case "missing":
      return t`Manjkajoča plačila`;
    case "other":
      return t`Ostalo`;
  }
};

export const buildHtmlQrCode = async (
  rawQrCodeData?: string,
  width?: string,
) => {
  // Generate QR Code as a Base64 Data URL (PNG image)
  const qrDataUrl = await QRCode.toDataURL(rawQrCodeData || "", {
    width: 10,
  });

  return `<img src="${qrDataUrl}" style="${width ? `width: ${width}` : "width: 50%"}; height: auto;" />`;
};

export const buildEscPosQrCode = (
  encodedData?: Uint8Array<ArrayBufferLike>,
) => {
  if (!encodedData) return [];

  const qrDataLength = encodedData.length + 3;
  return Uint8Array.from([
    // Center alignment
    0x1b,
    0x61,
    0x01,

    // Set QR code model
    0x1d,
    0x28,
    0x6b,
    0x04,
    0x00,
    0x31,
    0x41,
    0x32,
    0x00, // Model 2 (standard)

    // Set QR code size (increase to make it bigger)
    0x1d,
    0x28,
    0x6b,
    0x03,
    0x00,
    0x31,
    0x43,
    0x06, // Size 6

    // Set QR code error correction level (49 = M)
    0x1d,
    0x28,
    0x6b,
    0x03,
    0x00,
    0x31,
    0x45,
    0x31,

    // Store QR code data
    0x1d,
    0x28,
    0x6b,
    qrDataLength & 0xff, // pL
    (qrDataLength >> 8) & 0xff, // pH
    0x31,
    0x50,
    0x30, // cn, fn, m
    ...encodedData,

    // Print QR code
    0x1d,
    0x28,
    0x6b,
    0x03,
    0x00,
    0x31,
    0x51,
    0x30,

    // Reset alignment to left
    0x1b,
    0x61,
    0x00, // Left alignment
  ]);
};
